// @mui icons
// Material Kit 2 React components
import MKTypography from "components/MKTypography";

// Images
import logoGM from "assets/images/logo.png";

const date = new Date().getFullYear();

export default {
  brand: {
    name: "Gestoría Moreno Martín Alhambra",
    image: logoGM,
    route: "/",
  },
  socials: [],
  menus: [
    {
      name: "Contacto",
      items: [
        {
          name: "Dirección",
          href: "https://maps.google.com/?q=Avenida+Divina+Pastora+9,+18012+Granada",
          description: "Avenida Divina Pastora, 9, local 13, 18012 Granada",
        },
        {
          name: "Teléfono",
          href: "tel:+34958805110",
          description: "958 805 110 / 958 805 111 / 958 805 113",
        },
        {
          name: "Email",
          href: "mailto:info@gestoriamoreno.com",
          description: "info@gestoriamoreno.com",
        },
      ],
    },
    {
      name: "Legal",
      items: [
        { name: "Política de Privacidad", route: "/politica-privacidad" },
        { name: "Aviso Legal", route: "/aviso-legal" },
      ],
    },
  ],
  copyright: (
    <MKTypography variant="button" fontWeight="regular">
      &copy; {date} Gestoría Moreno Martín Alhambra. Todos los derechos reservados.
    </MKTypography>
  ),
};
